export const FAQLink: React.FC = () => {
  return (
    <a
      href="https://help.foodies-prime.com/a90c912ec0924032b0a794ccad390253"
      target="_blank"
      rel="noreferrer"
      className="autoliner-link autoliner-link-url"
    >
      FAQ
    </a>
  )
}
